import {
  getUser,
  getTeamMembers,
  getPortfolio,
  getDocuments,
  getInvestmentPlans,
  getFinancialAccounts,
  getPortfolioClassAllocations,
  getPortfolioHoldings,
  getNotifications
} from 'utils/Client/apiRequest'
import { objectIsEmpty, arrayIsEmpty } from 'utils/Client/storeUtils'
import actions from 'actions/index'

const {
  setUser,
  setTeamMembers,
  setPrimaryPortfolio,
  setInvestmentPlans,
  setPrimaryPortfolioAccounts,
  setPrimaryPortfolioClassAllocations,
  setPrimaryPortfolioHoldings,
  setDocuments,
  setLoadingPortfolio,
  setLoadingPortfolioClassAllocations,
  setLoadingPortfolioAccounts,
  setLoadingPortfolioHoldings,
  setLoadingDocuments,
  setNotifications,
} = actions

export const handleCoreRequests = async (dispatch, getState) => {
  handleTeamMembers(dispatch, getState)

  await Promise.all([
    handleUser(dispatch, getState),
  ])
}

export const handleCoreOverviewRequests = async (dispatch, getState) => {
  await handleCoreRequests(dispatch, getState)
  handleInvestmentPlans(dispatch, getState)
  handlePortfolioAccounts(dispatch, getState)
  handleDocuments(dispatch, getState)
  handleNotifications(dispatch, getState)

  await Promise.all([
    handlePrimaryPortfolio(dispatch, getState),
    handlePortfolioClassAllocations(dispatch, getState)
  ])
}

export const handleCorePortfolioRequests = async (dispatch, getState) => {
  await handleCoreRequests(dispatch, getState)
  handlePortfolioHoldings(dispatch, getState)

  await Promise.all([
    handlePrimaryPortfolio(dispatch, getState),
    handlePortfolioClassAllocations(dispatch, getState)
  ])
}

export const handleCoreDocumentsRequests = async (dispatch, getState) => {
  handleDocuments(dispatch, getState)
  await handleCoreRequests(dispatch, getState)
}

export const handleUser = async (dispatch, getState) => {
  const { user: { user } } = getState()
  if (objectIsEmpty(user)) {
    let userData

    try {
      userData = await getUser()
    } catch (e) {
      return false
    }

    if (userData) {
      const finalData = userData.data.attributes
      dispatch(setUser(finalData))
      return finalData
    }
  } else {
    return user
  }
}

export const handleTeamMembers = async (dispatch, getState) => {
  const { teamMembers: { teamMembers } } = getState()

  if (arrayIsEmpty(teamMembers)) {
    let teamMembersData

    try {
      teamMembersData = await getTeamMembers()
    } catch (e) {
      return false
    }

    if (teamMembersData) {
      dispatch(setTeamMembers(teamMembersData.data))
    }

    return teamMembersData
  } else {
    return teamMembers
  }
}

export const handleNotifications = async (dispatch, getState) => {
  const { notifications: { notifications } } = getState()

  if (arrayIsEmpty(notifications)) {
    let notificationsData

    try {
      notificationsData = await getNotifications()
    } catch (e) {
      return false
    }

    if (notificationsData) {
      dispatch(setNotifications(notificationsData.data))
    }

    return notificationsData
  } else {
    return notifications
  }
}

export const handleInvestmentPlans = async (dispatch, getState) => {
  const { investmentPlans } = getState()

  if (objectIsEmpty(investmentPlans.investmentPlans)) {
    let investmentPlansData

    try {
      investmentPlansData = await getInvestmentPlans()
    } catch (e) {
      return false
    }

    if (investmentPlansData) {
      dispatch(setInvestmentPlans(investmentPlansData.data))
    }

    return investmentPlansData
  } else {
    return investmentPlans
  }
}

export const handlePrimaryPortfolio = async (dispatch, getState) => {
  const { primaryPortfolio: { primaryPortfolio } } = getState()

  if (objectIsEmpty(primaryPortfolio)) {
    dispatch(setLoadingPortfolio(true))
    let userData

    try {
      userData = await handleUser(dispatch, getState)
    } catch (e) {
      dispatch(setLoadingPortfolio(false))
      return false
    }

    if (userData && userData.blackDiamondPortfolioId) {
      const { blackDiamondPortfolioId } = userData

      const portfolioData = await getPortfolio(blackDiamondPortfolioId)
      if (portfolioData) {
        dispatch(setPrimaryPortfolio(portfolioData))
        dispatch(setLoadingPortfolio(false))
      }
      return portfolioData
    }
  } else {
    return primaryPortfolio
  }
}

export const handlePortfolioAccounts = async (dispatch, getState) => {
  const { primaryPortfolioAccounts: { primaryPortfolioAccounts } } = getState()

  if (primaryPortfolioAccounts.length === 0) {
    dispatch(setLoadingPortfolioAccounts(true))
    try {
      let userData
      try {
        userData = await handleUser(dispatch, getState)
      } catch (e) {
        dispatch(setLoadingPortfolioAccounts(false))
        return false
      }

      if (userData && userData.blackDiamondPortfolioId) {
        const { blackDiamondPortfolioId } = userData
        const financialAccountsData = await getFinancialAccounts(blackDiamondPortfolioId)
        if (financialAccountsData) {
          dispatch(setPrimaryPortfolioAccounts(financialAccountsData))
          dispatch(setLoadingPortfolioAccounts(false))
        }
        return financialAccountsData
      }
    } catch (e) {
      dispatch(setLoadingPortfolioAccounts(false))
      return false
    }
  } else {
    return primaryPortfolioAccounts
  }
}

export const handlePortfolioClassAllocations = async (dispatch, getState) => {
  const {
    primaryPortfolioClassAllocations: {
      primaryPortfolioClassAllocations: { classAllocations }
    },
  } = getState()

  if (classAllocations.length === 0) {
    dispatch(setLoadingPortfolioClassAllocations(true))
    let userData

    try {
      userData = await handleUser(dispatch, getState)
    } catch (e) {
      return classAllocations
    }

    if (userData && userData.blackDiamondPortfolioId) {
      const { blackDiamondPortfolioId } = userData

      const classAllocationsData = await getPortfolioClassAllocations(blackDiamondPortfolioId)
      if (classAllocationsData) {
        dispatch(setPrimaryPortfolioClassAllocations(classAllocationsData, blackDiamondPortfolioId))
        dispatch(setLoadingPortfolioClassAllocations(false))
        return classAllocationsData
      }
      return classAllocationsData
    }
  } else {
    return classAllocations
  }
}

export const handlePortfolioHoldings = async (dispatch, getState) => {
  const {
    primaryPortfolioHoldings: {
      primaryPortfolioHoldings
    },
  } = getState()

  if (primaryPortfolioHoldings.length === 0) {
    dispatch(setLoadingPortfolioHoldings(true))
    let userData

    try {
      userData = await handleUser(dispatch, getState)
    } catch (e) {
      return primaryPortfolioHoldings
    }

    if (userData && userData.blackDiamondPortfolioId) {
      const { blackDiamondPortfolioId } = userData

      try {
        const portfolioHoldings = await getPortfolioHoldings(blackDiamondPortfolioId)
        if (portfolioHoldings) {
          dispatch(setPrimaryPortfolioHoldings(portfolioHoldings, blackDiamondPortfolioId))
          dispatch(setLoadingPortfolioHoldings(false))
        }
        return portfolioHoldings
      } catch (e) {
        throw e
      }
    }
  } else {
    return primaryPortfolioHoldings
  }
}

export const handleDocuments = async (dispatch, getState) => {
  const { documents: { documents } } = getState()
  if (arrayIsEmpty(documents)) {
    dispatch(setLoadingDocuments(true))
    let documentsData
    try {
      documentsData = await getDocuments()
    } catch (e) {
      return false
    }

    if (documentsData) {
      dispatch(setDocuments(documentsData.data))
      dispatch(setLoadingDocuments(false))
    }
    return documentsData
  } else {
    return documents
  }
}



// WEBPACK FOOTER //
// ./src/routing/thunks/handlers/client.js